export default {
      id: "btn_instagram-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "sprite.svg#btn_instagram",
      toString: function () {
        return this.url;
      }
    }